/*
 *   File : select-step.js
 *   Author : https://evoqins.com
 *   Description : Modal component to set step.
 *   Integrations : NA
 *   Version : 1.0.0
*/

// import packages
import { Icon } from "../Icon";
import { useNavigate } from "react-router-dom";


// import styles
import style from "../../Styles/Components/select-career.module.scss";


const STEPS_DATA = [
    {
        step_image: require("../../Assets/Images/Dashboard/step-1.png"),
        title: "Milestone",
        description: "Invest with purpose—whether it’s for a new house, a car, your child’s future, or other important milestones.",
        link: "/milestone"
    },
    {
        step_image: require("../../Assets/Images/Dashboard/step-2.png"),
        title: "Curated Portfolio",
        description: "Invest in a strategy aligned with your risk profile, choosing between active or index funds.",
        link: "/",
        state: {
            state: {
                basket: true
            }
        }
    },
    {
        step_image: require("../../Assets/Images/Dashboard/step-3.png"),
        title: "Import External Investments",
        description: "View, track, and manage all your mutual funds in a single interface.",
        link: "/portfolio",
        state: {
            state: {
                fund_type: 2,
            }
        },
    },
    {
        step_image: require("../../Assets/Images/Dashboard/step-4.png"),
        title: "Explore Funds",
        description: "Pick the funds you want and invest like a pro.",
        link: "/explore"
    }
]

const SelectStepModal = (props) => {
    const navigate = useNavigate();
    return (
        <div className={`modal fade ${style.e_select_career_modal}`}
            id="select-steps"
            tabIndex="-1"
            aria-labelledby="select-steps"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false">

            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content ${style.e_content} ${style.e_step} `}>
                    <div className="position-relative">
                        <Icon icon="close"
                            id="close-btn"
                            size={24}
                            className="cursor-pointer position-absolute right-24px top-24px d-none"
                            data-bs-dismiss="modal"
                            onClick={props.closeModal} />
                        <div className="d-flex justify-content-center">
                            <img src={require("../../Assets/Images/Dashboard/Illustration.png")}
                                alt="Select-type"
                                width={122}
                                height={122}
                                draggable={false} />

                        </div>
                        <h3 className="e-montserrat-bold e-font-18 e-line-height-28 color-eerie-black mb-3 text-center px-4">Make your selection and let's get started!</h3>
                        {/* <Slider slidesToShow={1}
                            slidesToScroll={1}
                            autoplaySpeed={3000}
                            fade={true}
                            autoplay={true}
                            dots={true}
                            arrows={false}
                            // {...settings}
                            dotsClass={"slick-dots e-steps-slider "}> */}
                        {
                            STEPS_DATA.map((item) => {
                                return (
                                    <div className="e-bg-soft-lavender box-shadow-tranparent-blue position-relative p-3 mx-4 mb-2 cursor-pointer e-step-card border-raadius-8px"
                                        data-bs-dismiss="modal"
                                        onClick={() => navigate(item.link, item.state ? item.state : undefined)}>
                                        <div className="d-flex justify-content-between mb-2">
                                            <h6 className="color-eerie-black e-font-14 e-montserrat-semi-bold margin-2px-bottom">{item.title}</h6>
                                            <Icon icon="arrow-right"
                                                size={16} />
                                        </div>
                                        <p className="color-jet-gray e-font-12 line-height-18px e-montserrat-medium pe-5 mb-3">{item.description}</p>
                                        <img src={item.step_image}
                                            alt={item.title}
                                            className="mb-2 position-absolute end-0 bottom-0 object-fit-contain"
                                            height={55}
                                            width={65}
                                        />

                                    </div>
                                )
                            })
                        }
                        {/* </Slider> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SelectStepModal